// src/components/common/CookieConsentBanner.js
import React, { useState, useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslations } from '../../languages';
import { setConsent, hasStoredConsent } from '../../services/analyticsService';

function CookieConsentBanner() {
  const { language } = useLanguage();
  const translations = getTranslations(language);
  const [showConsent, setShowConsent] = useState(false);
  
  useEffect(() => {
    // Check if we need to show the consent banner
    // Small delay to avoid flashing on initial load
    const timer = setTimeout(() => {
      const hasConsent = hasStoredConsent();
      setShowConsent(!hasConsent);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Cookie-Consent-Texte based on language
  const cookieTexts = {
    en: {
      message: "This website uses cookies to analyze traffic. We only load analytics after your explicit consent.",
      button: "Accept",
      decline: "Decline",
      policy: "Learn More"
    },
    de: {
      message: "Diese Website verwendet Cookies zur Verkehrsanalyse. Wir laden Analytics erst nach Ihrer ausdrücklichen Zustimmung.",
      button: "Akzeptieren",
      decline: "Ablehnen",
      policy: "Mehr Erfahren"
    }
  };

  const currentCookieText = cookieTexts[language];

  // Handler for accepting cookies
  const handleAcceptCookies = () => {
    console.log("Cookies accepted - Loading Google Analytics");
    setConsent(true);
  };

  // Handler for declining cookies
  const handleDeclineCookies = () => {
    console.log("Cookies declined - No Google Analytics");
    setConsent(false);
  };

  if (!showConsent) return null;

  return (
    <CookieConsent
      location="bottom"
      buttonText={currentCookieText.button}
      declineButtonText={currentCookieText.decline}
      cookieName="lucent-analytics-consent"
      style={{ 
        background: "rgba(40, 40, 40, 0.95)",
        zIndex: 9999,
        padding: "15px 20px",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.2)"
      }}
      buttonStyle={{ 
        backgroundColor: "#6B5ED9", 
        color: "#EEF2F0", 
        fontSize: "14px",
        borderRadius: "4px",
        padding: "8px 15px",
        fontWeight: "bold" 
      }}
      declineButtonStyle={{
        backgroundColor: "transparent",
        border: "1px solid #6B5ED9",
        color: "#6B5ED9",
        fontSize: "14px",
        borderRadius: "4px",
        padding: "8px 15px",
        marginLeft: "10px",
        fontWeight: "bold"
      }}
      expires={150}
      enableDeclineButton
      onAccept={handleAcceptCookies}
      onDecline={handleDeclineCookies}
    >
      {currentCookieText.message}{" "}
      <Link 
        to={`/${language}/privacy-policy`} 
        style={{ 
          color: "#4FCCED", 
          textDecoration: "underline",
          fontWeight: "bold"
        }}
      >
        {currentCookieText.policy}
      </Link>
    </CookieConsent>
  );
}

export default CookieConsentBanner;